import React from "react";
import CoreButton from "./CoreButton";

export default function CoreOutlinedButton(props) {
  return (
    <CoreButton {...props} variant="outlined">
      {props?.children}
    </CoreButton>
  );
}
